import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

const verticalMiddle = css`
  margin: auto 0;
`;

export const header = css`
  position: relative;
  text-align: center;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  border-bottom: 1px solid var(--neutral-black-30);
  padding: ${spacing.sm}px ${spacing.xs}px;

  ${mediaQuery(
    { min: minBreakpoints.M, max: maxBreakpoints.M },
    css`
      padding: ${spacing.md}px ${spacing.xl}px ${spacing.sm}px ${spacing.xl}px;
      border-bottom: 0 none;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${spacing.md}px ${spacing.xl}px ${spacing.sm}px ${spacing.xl}px;
      border-bottom: 0 none;
    `,
  )};
`;

export const headerInner = (searchBarVisible: boolean) => css`
  max-width: ${minBreakpoints.XL}px;
  margin: 0 auto;
  display: grid;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-template-columns: 1fr 42% auto 1fr;
      grid-template-areas: 'siteLogo searchBar curatorIcon iconBar';
      column-gap: ${spacing.sm}px;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-template-columns: 1fr 33% auto 1fr;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.XL },
    css`
      grid-template-columns: 1fr 46% auto 1fr;
    `,
  )};

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        'siteLogo iconBar'
        'secondRow secondRow';
      row-gap: ${searchBarVisible ? spacing.sm : 0}px;
      column-gap: 12px;
      align-items: center;
    `,
  )};
`;

export const siteLogo = css`
  ${verticalMiddle}

  grid-area: siteLogo;
  display: flex;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      margin-left: 8px;
    `,
  )};
`;

export const secondRowWrapper = css`
  /* On desktop, use display: contents so wrapper doesn't interfere with grid */
  display: contents;

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      display: grid;
      grid-area: secondRow;
      grid-template-columns: 1fr auto;
      column-gap: 12px;
      align-items: center;
      min-width: 0;

      /* When curator is not present, make search bar full width */
      &[data-has-curator='false'] {
        grid-template-columns: 1fr;
      }
    `,
  )};
`;

export const searchBarContainer = css`
  ${verticalMiddle}
  grid-area: searchBar;
  min-width: 0;

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      grid-area: unset;
      display: flex;
      flex-direction: column;
      min-width: 0;
    `,
  )};
`;

export const searchBarContainerHidden = css`
  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      display: none;
    `,
  )};
`;

export const curatorIconContainer = css`
  ${verticalMiddle}
  grid-area: curatorIcon;
  justify-self: end;

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      grid-area: unset;
      justify-self: end;
    `,
  )};
`;

export const iconBar = css`
  ${verticalMiddle}
  grid-area: iconBar;
  justify-self: end;
`;
